import { useLoaderData } from '@muse-web/router'

import type { TCollectionScreenLoaderData } from '../types/collectionScreenLoaderTypes'

export const useCollectionScreenLoaderData = useLoaderData<TCollectionScreenLoaderData>
